import React from 'react';
import { Link, Outlet } from 'react-router-dom';

const Dashboard = () => {
    return (
        <div class="drawer drawer-mobile">
            <input id="dashboard-sidebar" type="checkbox" class="drawer-toggle" />
            <div class="drawer-content">
                <h2 className='text-2xl font-bold'>Welcome to Dashboard</h2>
                <Outlet></Outlet>
            </div>
            <div class="drawer-side ">
                <label for="dashboard-sidebar" class="drawer-overlay"></label>
                <ul class="menu p-4 overflow-y-auto w-56 bg-blue-400 text-base-content">
                    {/* <!-- Sidebar content here --> */}
                    <li><Link className='text-white text-lg' to="/dashboard">My Appointments</Link></li>
                    <li><Link className='text-white text-lg' to="/dashboard/review">My Reviews</Link></li>
                    <li><Link className='text-white text-lg' to="/dashboard/history">My History</Link></li>
                    {/* {admin && <> */}
                    <li><Link className='text-white text-lg' to="/dashboard/users">All Users</Link></li>
                    <li><Link className='text-white text-lg' to="/dashboard/addDoctor">Add a Doctor</Link></li>
                    <li><Link className='text-white text-lg' to="/dashboard/manageDoctor">Manage Doctors</Link></li>
                    {/* </>} */}
                </ul>

            </div>
        </div>
    );
};

export default Dashboard;